import {Company} from '@legit-health/ui';
import {TFunction} from 'i18next';
import {CurrentPractitioner} from '@/practitioner/interfaces/Practitioner';

export default function generateSupportEmailTo(
  currentPractitioner: CurrentPractitioner,
  company: Company,
  t: TFunction
) {
  const body = encodeURIComponent(
    `👉 ${t('shared/common:contact.mailTo.placeholder')} 

――― 
${t('shared/common:medicalCenter')}: ${company.name} 
${t('practitioner:form.role')}: ${currentPractitioner.role.label}
${t('shared/common:user')}: ${currentPractitioner.fullname}`
  );
  return `mailto:${t('shared/common:contact.help.email')}?cc=${company.billingEmail}&subject=${t(
    'shared/common:contact.mailTo.emailFrom'
  )}  ${currentPractitioner.fullname} 
    (${currentPractitioner.locale}) via app.legit.health&body=${body}
  `;
}
